import { Component, OnInit } from '@angular/core';
import { NavShareService } from '../../../services/core/nav-share.service';
import { AuthenticationFacade } from '../../../store/authentication/authentication.facade';
import { Store } from '@ngrx/store';
import { selectRouteData } from '../../../store/router/router.selector';
import { Observable } from 'rxjs';
import { Data } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    routeData$ = new Observable<Data>();

    constructor(
        private authenticationFacade: AuthenticationFacade,
        private navShareService: NavShareService,
        private store: Store
    ) {}

    ngOnInit() {
        this.routeData$ = this.store.select(selectRouteData);
    }

    collapsePushed(): void {
        this.navShareService.toggleCollapseState();
    }

    signOut(): void {
        this.authenticationFacade.signOut();
    }
}
